export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10523.54c53fa8.jpg";